import React, { useState } from "react";

export default function DropdownCell({ value, column, readOnly, onCommit }) {
  const [open, setOpen] = useState(false);
  const options = column?.settings?.options || [];
  const multiple = !!column?.settings?.multiple;
  const selected = multiple ? (Array.isArray(value) ? value : []) : value ? [value] : [];

  const toggle = (optId) => {
    if (multiple) {
      const next = selected.includes(optId) ? selected.filter((x) => x !== optId) : [...selected, optId];
      onCommit(next.length ? next : null);
    } else {
      setOpen(false);
      onCommit(selected[0] === optId ? null : optId);
    }
  };

  const labelFor = (id) => options.find((o) => o.id === id)?.label || id;

  return (
    <div className="cell-display dropdown">
      <button
        type="button"
        className="dropdown-display"
        disabled={readOnly}
        onClick={() => !readOnly && setOpen((o) => !o)}
      >
        {selected.length === 0 ? (
          <span className="placeholder">—</span>
        ) : (
          selected.map((id) => (
            <span key={id} className="dropdown-chip">{labelFor(id)}</span>
          ))
        )}
      </button>
      {open && (
        <>
          <div className="cell-menu-backdrop" onClick={() => setOpen(false)} />
          <div className="cell-menu dropdown-menu-pop">
            {options.length === 0 && <div className="people-empty">No options configured</div>}
            {options.map((o) => {
              const isSel = selected.includes(o.id);
              return (
                <button
                  key={o.id}
                  type="button"
                  className={`people-menu-item ${isSel ? "selected" : ""}`}
                  onClick={() => toggle(o.id)}
                >
                  <span className="people-menu-name">{o.label}</span>
                  {isSel && <span className="people-check">✓</span>}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
